import React from 'react';
import { Col, Icon, Input, message, Modal, Row, Switch, Upload } from 'antd';

import { 
	API_ENDPOINT
} from '../../index';

class WhiteLabelModal extends React.Component{

	render(){

		const formMargin = 16;

		return (
			<Modal
				visible={ this.props.modalVisible} 
				onOk={ this.props.handleOk }
				onCancel={ this.props.handleCancel }
				>
					{/* 
						logo 
						host, enabled,
						primaryColor,
						secondaryColor,
					*/}

					<Row style={{ marginBottom: formMargin }}>
						<Col>
							<Upload
								name="picture"
								className="logo-uploader"
								listType="picture-card"
								showUploadList={false}
								action={`${API_ENDPOINT}/api/upload/white-label-assets`}
								beforeUpload={ this.handleBeforeUpload }
								onChange={ this.handleOnChangeUploadStatus }>

								<div style={{ width: 255 }}>
									<Icon type={this.state.uploadingImage ? 'loading' : 'plus'} />
									<div>
										Upload Logo
									</div>
								</div>

							</Upload>
						</Col>
					</Row>

					<Row style={{ marginBottom: formMargin }}>
						<Col>
							<Switch checkedChildren="White Label Enabled" unCheckedChildren={"White Label Disabled"} />
						</Col>
					</Row>

					<Row style={{ marginBottom: formMargin }}>
						<Col>
							<Switch checkedChildren="Eezee Member Enabled" unCheckedChildren={"Eezee Member Disabled"} />
						</Col>
					</Row>
					
					<Row style={{ marginBottom: formMargin }} gutter={formMargin}>
						<Col>
							<label>Domain Name</label>
							<Input />
						</Col>
					</Row>

					<Row style={{ marginBottom: formMargin }}>
						<Col>
							<label>Primary Color</label>
							<Input />
						</Col>
					</Row>

					<Row style={{ marginBottom: formMargin }}>
						<Col>
							<label>Secondary Color</label>
							<Input />
						</Col>
					</Row>

					<Row style={{ marginBottom: formMargin }}>
						<Col>
							<label>Google Analytics</label>
							<Input />
						</Col>
					</Row>

				
				</Modal>
		)

	}

	constructor( props ){
		super(props);

		this.state = {
			uploadingImage: false
		};
	}

	handleBeforeUpload = ( ) => {

		message.loading('Uploading Logo');

		this.setState({ uploadingImage: true });

	}

	handleOnChangeUploadStatus = ( info ) => {
		
		if (info.file.status === 'done') {
			message.destroy();
			message.success(`${info.file.name} file uploaded successfully`);

			this.props.setUserWhiteLabelImage( info.file.response.productImage.url );

			this.setState({
				uploading: false
			});

		} else if (info.file.status === 'error') {
			message.destroy();
			message.error(`${info.file.name} file upload failed.`);

			this.setState({
				uploading: false
			});

		}

	}

}

export default WhiteLabelModal;


// WEBPACK FOOTER //
// ./src/components/supplier-profile/white-label-editor.js